import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ActiveFilterList from './ActiveFilterList';
import Pagination from './Pagination';
import Post from './Post';

class PostList extends Component {

  render() {
    if (this.props.response === null) { // No response received (yet, or at all)
      return (
        <section className="message">
          <div className="message__container">
            <span className="result-count">Showing 0 of 0 results</span>
            <ActiveFilterList applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} orderedActiveFilterList={this.props.orderedActiveFilterList} wpData={this.props.wpData} />
            <h2>No Results</h2>
            <p>Try adjusting your search to view more results.</p>
          </div>
        </section>
      );
    } 
    else if (typeof this.props.response === 'object') { // Response of some sort received!
      if (this.props.response.posts.length > 0) {
        // Setup results count text
        let resultCountText = 'Showing ';
        let startNumber = this.props.pagination.perPage * (this.props.query.page - 1) + 1;
        if (this.props.response.posts.length === this.props.pagination.perPage) {
          resultCountText += startNumber + '-' + (startNumber + this.props.pagination.perPage - 1);
        }
        else {
          resultCountText += startNumber + '-' + (startNumber + this.props.response.posts.length - 1);
        }
        resultCountText += ' of ' + this.props.response.totalPosts + ' results';

        return(
          <section className="PostList">
            <div className="PostList__container">
              <span className="result-count">{resultCountText}</span>
              <ActiveFilterList applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} orderedActiveFilterList={this.props.orderedActiveFilterList} wpData={this.props.wpData} />

              <ul className="post-list post-list--wide">
                {this.props.response.posts.map((post, index) => // Loop through posts and display them
                  <Post key={index} post={post} wpData={this.props.wpData} />
                )}
              </ul>

              <Pagination pagination={this.props.pagination} paginationClick={function(data){ this.props.paginationClick(data); }.bind(this)} query={this.props.query} response={this.props.response} />
            </div>
          </section>
        );
      }
      else {
        return (
          <section className="message">
            <div className="message__container">
              <span className="result-count">Showing 0 of 0 results</span>
              <ActiveFilterList applyFilter={function(data) { this.props.applyFilter(data) }.bind(this)} orderedActiveFilterList={this.props.orderedActiveFilterList} wpData={this.props.wpData} />
              <h2>No Results</h2>
              <p>Try adjusting your search to view more results.</p>
            </div>
          </section>
        );
      }
    } 
    else { // Catch-all error
      return(
        <section className="error">
          <div className="error__container">
            <h2>Error</h2>
            <p>Sorry, the search application encountered an error. Please try your search again.</p>
          </div>
        </section>
      );
    }
  };
}

PostList.propTypes = {
  applyFilter: PropTypes.func,
  filterOptions: PropTypes.object,
  orderedActiveFilterList: PropTypes.array,
  pagination: PropTypes.object,
  paginationClick: PropTypes.func,
  query: PropTypes.object,
  response: PropTypes.object,
  wpData: PropTypes.object,
};

export default PostList;


// WEBPACK FOOTER //
// ./src/components/PostList.js